import { z } from "zod";

import { reportSchemaError } from "@/diagnostics/schema-error.ts";
import { BikewayCollectionSchema, type BikewayCollection } from "./bikeway.model.ts";

/**
 * The baked bike-infrastructure lines. Regenerate with `aube run bikeways`.
 *
 * Fetched lazily — only once the overlay is actually switched on — because at
 * ~2 MB it is the largest thing the app loads and a viewer who has turned the
 * overlay off should not pay for it. A build artefact rather than a network
 * payload, and parsed for the same reason districts are: a stale bake from an
 * older schema is the failure that actually happens.
 */
export async function fetchBikeways(): Promise<BikewayCollection> {
  const res = await fetch("/bikeways.geojson");
  if (!res.ok) throw new Error(`/bikeways.geojson → HTTP ${res.status}`);

  const parsed = BikewayCollectionSchema.safeParse(await res.json());
  if (!parsed.success) {
    // Toast + console here; the throw lets the caller fall back to no overlay.
    reportSchemaError("BikewayCollection", parsed.error);
    throw new Error(`/bikeways.geojson → ${z.prettifyError(parsed.error)}`);
  }

  return parsed.data;
}
